module.exports = __webpack_public_path__ + "static/img/Briton-Nikora.bd4568a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Briton-Nikora.jpg
// module id = F7vz
// module chunks = 0